import gql from 'graphql-tag'

export const QueryGetItemListGroup = gql`
    query getUiLinkListGroup($groupname: String) {
        getUiLinkListGroup(groupname: $groupname){
            title
            description
            imageurl
            id
            accesscounter
            lastaccessstr
            creationdatestr
            avgdayusage
        }
    }
`

export const QueryGetItemListByTitle = gql`
    query QueryGetItemListByTitle($title: String!) {
        getUiLinkListByTitle(title: $title){
            title
            description
            imageurl
            id
            accesscounter
            lastaccessstr
            creationdatestr
            avgdayusage
        }
    }
`
export const QueryGetGroupList = gql`
query {
    getGroupList
}
`

export const QueryAutocompleteCellname = gql`
query QueryAutocompleteCellname($val: String!) {
    getAutocompleteCellname(val: $val){
        val
        text
    }
}
`

export const QueryGetUiLinkByName = gql`
query QueryGetUiLinkByName($name: String!) {
    getUiLinkByName(name: $name){
        id
    }
}
`

export const QueryGetTodayHoliday = gql`
query QueryGetTodayHoliday {
    getTodayHoliday{
        image
        background
        audio
        name
    }
}
`

export const QueryGetUserPhoto = gql`
query QueryGetUserPhoto {
    getUserPhoto
}
`

//Mutation to register access
export const increaseAccessCountById = gql`
  mutation increaseAccessCount($id: Int!) {
    increaseAccessCount(id: $id) {
      id,
      url
    }
  }
`;